import React, { useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import StyledDataGrid from "components/StyledDataGrid/StyledDataGrid.js";
import TankHistoryDialog from "components/TankHistoryDialog/TankHistoryDialog.js";

import homePageStyle from "assets/jss/material-kit-pro-react/views/homePageStyle.js";

function TankStatusReport(props) {
  const useStyles = makeStyles(homePageStyle);
  const classes = useStyles();

  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [historyRow, setHistoryRow] = useState({});

  const columns = [
    {
      field: "facility",
      headerName: "Facility",
      flex: 75,
      minWidth: 110,
    },
    {
      field: "city",
      headerName: "City",
      flex: 100,
      minWidth: 150,
    },
    {
      field: "state",
      headerName: "State",
      flex: 75,
      minWidth: 100,
    },
    {
      field: "tank_name",
      headerName: "Tank Name",
      flex: 125,
      minWidth: 200,
    },
    {
      field: "color",
      headerName: "History",
      flex: 75,
      minWidth: 120,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const historyButton = (
          <Button
            variant="contained"
            style={{ backgroundColor: "#bfb4a0" }}
            size="small"
            onClick={() => {
              setHistoryRow(params.row);
              setHistoryDialogOpen(true);
            }}
          >
            History
          </Button>
        );
        return historyButton;
      },
    },
    {
      field: "date",
      headerName: "Date",
      flex: 75,
      minWidth: 100,
    },
    {
      field: "oil_level",
      headerName: "Volume [gal]",
      flex: 100,
      align: "center",
      headerAlign: "center",
      minWidth: 145,
    },
    {
      field: "tank_reading",
      headerName: "Percent Full",
      flex: 100,
      align: "center",
      valueFormatter: (params) => `${params.value} %`,
      minWidth: 140,
    },
    {
      field: "type",
      headerName: "Event",
      flex: 100,
      minWidth: 100,
    },
    {
      field: "gallons_removed",
      headerName: "Change [gal]",
      flex: 100,
      align: "center",
      minWidth: 145,
    },
    {
      field: "tank_capacity",
      headerName: "Capacity [gal]",
      flex: 100,
      align: "center",
      minWidth: 150,
    },
    {
      field: "image",
      headerName: " ",
      flex: 75,
      minWidth: 75,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: classes.hideRightSeparator,
      renderCell: (params) => {
        const imageButton = (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => props.handleTankImageDialogOpen(params.row)}
          >
            Image
          </Button>
        );
        return imageButton;
      },
    },
    {
      field: "event_",
      headerName: "Add",
      flex: 75,
      minWidth: 75,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerAlign: "center",
      headerClassName: classes.hideRightSeparator,
      renderCell: (params) => {
        const eventButton = (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              const row = params.row;
              props.handleHistoryDialogOpen(
                row.facility,
                row.site_id,
                row.tank_name,
                row.tank_capacity.toLocaleString(),
                row.type,
                row.images
              );
            }}
          >
            Event
          </Button>
        );
        return eventButton;
      },
    },
    {
      field: "contact",
      headerName: " ",
      flex: 75,
      minWidth: 75,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: classes.hideRightSeparator,
      renderCell: (params) => {
        const contactButton = (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => props.handleAddContactDialogOpen(params.row)}
          >
            Contact
          </Button>
        );
        return contactButton;
      },
    },
  ];

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ height: 600, width: "100%" }}>
        <StyledDataGrid
          rows={props.rows}
          columns={columns}
          pageSize={15}
          rowsPerPageOptions={[15]}
          getCellClassName={(params) => {
            if (params.field === "tank_reading") {
              const alertLevel = Number(params.row.alert_level);
              if (alertLevel === 0) {
                return classes.alertOrange;
              } else if (alertLevel === 1) {
                return classes.alertRed;
              } else {
                return classes.alertGreen;
              }
            }
            return "";
          }}
        />
      </div>
      <TankHistoryDialog
        open={historyDialogOpen}
        row={historyRow}
        onClose={() => setHistoryDialogOpen(false)}
      />
    </div>
  );
}

TankStatusReport.displayName = "TankStatusReport";
TankStatusReport.propTypes = {
  rows: PropTypes.array.isRequired,
  handleHistoryDialogOpen: PropTypes.func.isRequired,
  handleTankImageDialogOpen: PropTypes.func.isRequired,
  handleAddContactDialogOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
};

export default TankStatusReport;
